import Resizer from 'react-image-file-resizer'

export const convertToJPEG = async (imageFile: File): Promise<File> => {
  return new Promise(resolve => {
    Resizer.imageFileResizer(
      imageFile,
      800, // New width
      600, // New height
      'JPEG', // Output format
      100, // Quality
      0, // Rotation
      uri => {
        resolve(uri as File)
      }, // URI of resized image
      'file', // Output type
      0, // minWidth file size (optional)
      0, // minHeight file size (optional)
    )
  })
}

export const canvasToFile = (
  canvas: HTMLCanvasElement,
  fileName = 'capture.jpg',
): Promise<File> => {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      blob => {
        if (!blob) {
          reject(new Error('Failed to create image blob'))
          return
        }

        resolve(
          new File([blob], fileName, {
            type: 'image/jpeg',
          }),
        )
      },
      'image/jpeg',
      0.9,
    )
  })
}

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      resolve(reader.result as string)
    }

    reader.onerror = reject

    reader.readAsDataURL(file)
  })
}

type CanvasToCompressedFileParams = { canvas: HTMLCanvasElement; fileName: string; quality: number }

export const canvasToCompressedFile = ({
  canvas,
  fileName,
  quality,
}: CanvasToCompressedFileParams): Promise<File> => {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      blob => {
        if (!blob) {
          reject(new Error('Failed to create image blob'))
          return
        }

        resolve(
          new File([blob], fileName, {
            type: 'image/jpeg',
          }),
        )
      },
      'image/jpeg',
      quality,
    )
  })
}
